import styled from "@emotion/styled";
import { colorGuide, colorPalette } from "../../theme/colors";

export const TabsContainer = styled.div`
  display: inline-flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background: ${colorGuide.lightComponents.secondaryTab.bgColor};
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1) inset;
`;

export const TabsWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  position: relative;
`;

export const TabItem = styled.button<{
  isActive: boolean;
  disabled?: boolean;
}>`
  cursor: pointer;
  display: flex;
  padding: 7px 24px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 20px;
  box-shadow: ${(props) =>
    props.isActive ? "0px 0px 6px 0px rgba(0, 0, 0, 0.1)" : ""};

  border: none;
  background: ${(props) =>
    props.isActive
      ? colorGuide.lightComponents.secondaryTab.tabItem.active.bgColor
      : colorGuide.lightComponents.secondaryTab.tabItem
          .bgColor}; /* Active background */
`;
